export default __webpack_public_path__ + "static/media/cholet11.35459147.jpg";